module.exports = __webpack_public_path__ + "static/assets/da2c14a26cf998248b94a1888ba71e86.png";